<template>
	<div class="container">
		<!-- 顶部栏 -->
		<div class="topbar">
			<div>
				<el-input v-model="searchValue" placeholder="标题/描述/类型/用户昵称" size="small" prefix-icon="el-icon-search"
					class="search-input" @keyup.native.enter="search()" />
				<el-button type="primary" icon="el-icon-search" size="small" @click.stop="search()">
					搜索
				</el-button>
			</div>
			<el-button type="primary" size="small" icon="el-icon-plus" @click.stop="handleCreate()">
				新增问题
			</el-button>
		</div>

		<div>
			<el-select v-if="userDataTypeOptions.length > 0" clearable v-model="curUserDataType" @change="curUserDataTypeChange">
				<el-option v-for="item in userDataTypeOptions" :key="item.value" :value="item.value"
					:label="item.name"></el-option>
			</el-select>

			<el-select style="padding-left: 20px;" clearable v-model="curTopOption" @change="curTopOptionChange">
				<el-option v-for="item in topOptions" :key="item.value" :value="item.value" :label="item.label">
				</el-option>
			</el-select>

			<el-select style="padding-left: 20px;" clearable v-model="curCategoryOption"
				@change="curCategoryOptionChange">
				<el-option v-for="item in categories" :key="item.forumCategoryID" :label="item.categoryName"
					:value="item.categoryName">
				</el-option>
			</el-select>
		</div>

		<!-- 内容 -->
		<el-table border ref="tableData" v-loading="loading" :data="tableData"
			:header-cell-style="{ background: '#F5F7FA' }" style="width: 100%; margin-bottom: 20px;margin-top: 20px;">
			<el-table-column label="ID" prop="problemId" width="100px" align="center" />
			<el-table-column label="问题" prop="title" align="center" show-overflow-tooltip />
			<el-table-column label="描述" prop="description" align="center" show-overflow-tooltip />
			<el-table-column label="创建日期" prop="createTime" align="center">
				<template slot-scope="scope">
					{{ scope.row.createTime | formatDateTime }}
				</template>
			</el-table-column>
			<el-table-column label="提交用户" prop="nickname" align="center" />
			<el-table-column label="麦粒值" prop="worth" align="center" />
			<el-table-column v-if="userDataTypeOptions.length > 0" label="所属领域" align="center">
				<template slot-scope="scope">
					{{ scope.row.userDataType | userDataTypeTransform }}
				</template>
			</el-table-column>
			<el-table-column label="类型" align="center" prop="category">

			</el-table-column>
			<el-table-column label="回答个数" prop="answerCount" align="center" />
			<el-table-column label="最佳答案" prop="bestAsStatus" align="center">
				<template slot-scope="scope">
					<el-tag size="medium" :type="scope.row.bestAsStatus === 0 ? 'danger' : 'primary'">
						{{ scope.row.bestAsStatus === 0 ? "无" : "有" }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="置顶状态" prop="isTop" align="center">
				<template slot-scope="scope">
					<el-button @click="handleSwitchTop(scope.row)" size="small"
						:type="scope.row.isTop ? 'danger' : 'primary'">{{ scope.row.isTop ? "取消置顶" : "置顶" }}</el-button>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="250" align="center">
				<template slot-scope="scope">
					<!-- <el-button size="small" :type="scope.row.isTop ? 'warning' : 'primary'"
						@click.stop="handleSwitchTop(scope.row)">
						{{ scope.row.isTop ? "取消置顶" : "设为置顶" }}
					</el-button> -->
					<el-button size="small" type="primary" @click.stop="goToQuizDetail(scope.row)">
						查看
					</el-button>
					<el-button size="small" :type="scope.row.isDeleted ? 'warning' : 'danger'"
						@click.stop="handleDelete(scope.row)">
						{{ scope.row.isDeleted ? "恢复" : "删除" }}
					</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页 -->
		<el-pagination v-show="totalCount > pageSize" background layout="prev, pager, next" :total="totalCount"
			:page-size="pageSize" :current-page="currentPage" @current-change="currentChange" />

		<!-- 添加问题对话框 -->
		<el-dialog title="添加问题" width="60%" :visible.sync="addProblemVisible">
			<el-form :model="addProblemForm" label-position="top" @submit.native.prevent="createProblem"
				ref="createProblemForm">
				<el-form-item label="标题" prop="title" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
					<el-input v-model="addProblemForm.title"></el-input>
				</el-form-item>
				<el-form-item label="描述" prop="description">
					<el-input v-model="addProblemForm.description"></el-input>
				</el-form-item>
				<el-form-item v-if="userDataTypeOptions.length > 0" label="帖子领域" prop="userDataType"
					:rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
					<el-select v-model="addProblemForm.userDataType">
						<el-option v-for="item in userDataTypeOptions" :label="item.name"
							:value="item.value" :key="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="类型" prop="category" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
					<el-select v-model="addProblemForm.category">
						<el-option v-for="item in categories" :key="item.forumCategoryID" :label="item.categoryName"
							:value="item.categoryName"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="悬赏额（麦粒）" prop="worth"
					:rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
					<el-input-number v-model.number="addProblemForm.worth"></el-input-number>
				</el-form-item>
				<el-form-item label="发布模式" prop="publishMode"
					:rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
					<el-select v-model="addProblemForm.publishMode" style="width: 300px">
						<el-option label="公开 (所有用户可见)" :value="0"></el-option>
						<el-option label="私有 (用户不可见,仅邀请的专家可见)" :value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="关键字" prop="keyWord">
					<el-input v-model="addProblemForm.keyWord" placeholder="关键字，多关键字用逗号隔开 选填"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="small" native-type="submit">保存</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getProblemList,
		updateProblem,
		deleteProblemOrBack,
		addProblem,
		getCategoryList
	} from "@/api/mai/quizManagement/quizManagement";
	import {
		deepClone
	} from "@/utils/index"
	import {
		handleRes
	} from "@/utils/handleRes";
	import {
		isVaild
	} from "@/utils/validate"
  import {getUserType} from "@/utils/userutil";
  import {getNavigationItemObj, setNavigationItemWithObj} from "@/utils/NavigationUtils";
	export default {
		data() {
			return {
        navigationKey:"quizList",

				activeIndex: "0", // 当前索引
				loading: false, // 加载开关
				searchValue: "", // 搜索内容
				totalCount: 0, // 列表总数
				pageSize: 10, // 单页条数
				currentPage: 1, // 当前页码
				tableData: [],
				userDataTypeOptions: [],
				curUserDataType: "",
				topOptions: [{
					value: 0,
					label: "全部"
				}, {
					value: 1,
					label: "置顶"
				}],
				curTopOption: "",
				addProblemVisible: false,
				categories: [],
				curCategoryOption: "",
				addProblemForm: {}
			}
		},
		created() {
      let navigationObj = getNavigationItemObj(this.navigationKey)
      this.searchValue = navigationObj.searchValue
      this.curCategoryOption = navigationObj.curCategoryOption
      this.currentPage = navigationObj.currentPage
      this.curTopOption = navigationObj.curTopOption
      this.curUserDataType = navigationObj.curUserDataType

      this.userDataTypeOptions = getUserType()
			this.getProblemList();
			this.fetchCategory();
		},
		methods: {
			curCategoryOptionChange() {
				this.search()
			},
			curUserDataTypeChange() {
				this.search()
			},
			curTopOptionChange() {
				this.search()
			},
			/**
			 * 搜索
			 */
			search() {
				this.currentPage = 1;
				this.getProblemList();
			},
			/**
			 * 翻页
			 *
			 * @param {number} currentPage 当前页码
			 */
			currentChange(currentPage) {
				this.currentPage = currentPage;
				this.getProblemList();
			},
			/**
			 * @description: 获取类别
			 * @param {*}
			 * @return {*}
			 */
			fetchCategory() {
				this.categories = [];
				getCategoryList().then(res => {
					if (isVaild(res)) {
						this.categories = res.data
					}
				})
			},
			resetForm() {
				this.addProblemForm = {
					userDataType: 0,
					publishMode: 0
				};
			},
			/**
			 * @description: 打开添加问题对话框
			 * @param {*}
			 * @return {*}
			 */
			handleCreate() {
				this.resetForm();
				this.addProblemVisible = true;
				this.$nextTick(() => {
					this.$refs.createProblemForm.clearValidate();
				});
			},
			/**
			 * @description: 确认添加问题
			 * @param {*}
			 * @return {*}
			 */
			createProblem() {
				this.$refs["createProblemForm"].validate((valid) => {
					if (valid) {
						const params = deepClone(this.addProblemForm);
						addProblem(params).then((res) => {
							console.log(res);
							handleRes(res, () => {
								this.addProblemVisible = false;
								this.search();
							})

						});
					} else {
						this.$message({
							type: "error",
							message: "请完善数据",
						});
					}
				});
			},
			/**
			 * 获取所有问题列表
			 */
			getProblemList() {
				this.loading = true;
				const params = {
					sortName: "",
					sortOrder: "",
					pageNumber: this.currentPage,
					pageSize: this.pageSize,
					keyWord: this.searchValue,
				};

				if (isVaild(this.curUserDataType)) {
					params.userDataType = this.curUserDataType
				}

				let where = []

				if (isVaild(this.curTopOption) && this.curTopOption !== 0) {
					where.push({
						"field": "isTop",
						"value": this.curTopOption,
						"op": "equal"
					})
				}

				if (isVaild(this.curCategoryOption)) {
					where.push({
						"field": "category",
						"value": "'" + this.curCategoryOption + "'",
						"op": "equal"
					})
				}

				if (where.length > 0) {
					params.where = where
				}

        setNavigationItemWithObj(this.navigationKey,{
          currentPage:this.currentPage,
          searchValue:this.searchValue,
          curUserDataType:this.curUserDataType,
          curTopOption :this.curTopOption,
          curCategoryOption:this.curCategoryOption
        })

				getProblemList(params).then((res) => {
					this.tableData = res.data.rows;
					this.totalCount = res.data.total;
					this.utils.stopLoading(this);
				});
			},
			/**
			 * 设置或者取消问题置顶
			 *
			 * @param {object} row 所选对象信息
			 */
			handleSwitchTop(row) {
				let data = deepClone(row)
				data.isTop = !data.isTop
				updateProblem(data).then(res => {
					handleRes(res, () => {
						this.getProblemList()
					})
				})
			},
			/**
			 * 删除问题
			 *
			 * @param {object} row 所选对象信息
			 */
			handleDelete(row) {
				deleteProblemOrBack({
					problemId: row.problemId
				}).then(res => {
					handleRes(res, () => {
						this.getProblemList()
					})
				})
			},
			/**
			 * 跳转到用户详情
			 *
			 * @param {object} row 所选对象信息
			 */
			goToQuizDetail(row) {
				this.$router.push({
					path: "quizDetail",
					query: {
						problemId: row.problemId,
					}
				});
			},
		},
	}
</script>

<style>
</style>
